import { useContext, useState, useCallback, useEffect } from 'react';
import ProductView from './Components/ProductView/ProductView';
import Checkout from './Components/Checkout/Checkout';
import Dialog from './Components/Dialog';
import { useStore } from './store';
import { Context} from './store/Context';

function App() {     

     // local state  
    const [ showProducts, setShowProducts] = useState(false);
    const [ showCheckout, setShowCheckout] = useState(false);
    const [ showDialog, setShowDialog] = useState(false);
    const [ message, setMessage] = useState('');       

    const [ 
        state,
        addOrder, 
        removeOrder, 
        removeCategoryOfItems,
        resetStore
    ] = useStore('store');  

    const { contextState } = useContext( Context );
  
    const add = (product) => addOrder(product);
    const remove = (orderID) => removeOrder(orderID);
    const removeCategory = (productID) => removeCategoryOfItems(productID);

    const closeDialog= () => setShowDialog(false);  

    const checkout = () => {
        const { orders } = state;
        if(!orders.length) {
            setMessage(`You haven't order anything yet`);
            return setShowDialog(true);
        }
       setShowProducts(false);
       setShowCheckout(true);
    }

    const resetToBaseView = useCallback( () => {  
        setShowProducts(true);
        setShowCheckout(false);
    }, [
        setShowProducts, 
        setShowCheckout
    ]);          

    /***
     * Wait with displaying products 
     * until store state has been configured
     */ 
    useEffect( () => {     
        if(contextState) {
            setShowProducts(true);
        }
    }, [ contextState]);

    /***
     * Reset base view if there are no orders
     */ 
    const { orders, products } = state;   
    useEffect( () => {
        if(orders && !orders.length && setShowCheckout) {
            resetToBaseView();
        }      
    }, [ 
        orders,
        showCheckout,
        resetToBaseView
    ]);   
    
    return (<>        
        <Dialog
            open={showDialog}
            handleClose={closeDialog}
            msg={message}
        />        
        {showProducts && <ProductView 
            state={state}
            products={products}
            add={add}
            reset={resetStore}
            checkout={checkout}
            currencyIcon={state.currencyIcon}
            removeCategory={removeCategory}
        />}
        {showCheckout && <Checkout    
            state={state}
            edit={resetToBaseView}    
            remove={remove}           
        />}    
  </>);
}

export default App;
